{
  "connected": "Live updates on",
  "disconnected": "Live updates paused, reconnecting…"
}
